import { createContext, useContext, useState } from "react";
import styled from "styled-components";
import { Column } from "styled/alignment/Column";
import colors from "theme/colors";


const AccordionContext = createContext();

export function Accordion({ children }) {
  const [open, setOpen] = useState({});

  function toggle(id) {
    setOpen(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  }

  return (
    <AccordionContext.Provider value={{ open, toggle }}>
      {children}
    </AccordionContext.Provider>
  );
}



export function AccordionItem({ id, header, children }) {
  const { open, toggle } = useContext(AccordionContext);

  return (
    <StyledColumn visible={open[id] ? 1 : 0}>
      <Container>
        <ContentHeader
          onClick={() => toggle(id)}
          border={open[id] ? 1 : 0}
        >
          {header}
          <span>{open[id] ? <ArrowUp /> : <ArrowDown />}</span>
        </ContentHeader>

        {open[id] && (
          <ContentBody>
            {children}
          </ContentBody>
        )}
      </Container>
    </StyledColumn>
  );
}


const StyledColumn = styled(Column)`
  border: 1px solid #ddd;
  border-radius: 8px;
  background: ${colors.neutralLight};
  margin-bottom: 4px;

  ${({ visible }) => visible == 0 && `
    &:hover {
      background: #f8fafc;
      cursor: pointer;
    }
  `}
`;

const Container = styled.div``;

const ContentHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;  
  border-radius: 0px;
  cursor: pointer;

  ${({ border }) => border == 1 && `
    border-bottom: 1px solid #ddd;
    border-radius: 0px;
    &:hover {
      border-radius: 8px 8px 0px 0px;
      background: #f8fafc;
    }
  `}

  ${({ border }) => border == 0 && `
    &:hover {
      border-radius: 8px;
      background: #f8fafc;
    }
  `}
`;

const ContentBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  padding: 15px 16px;
  border-radius: 0 0 8px 8px;   
`;

const ArrowDown = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 8px;
    height: 2px;
    background: ${colors.night};
    border-radius: 2px;
    top: 4px;
  }

  &::before {
    left: 0;
    transform: rotate(45deg);
  }

  &::after {
    right: 0;
    transform: rotate(-45deg);
  }
`;

const ArrowUp = styled.div`
  position: relative;
  width: 12px;
  height: 12px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 8px;
    height: 2px;
    background: ${colors.night};
    border-radius: 2px;
    top: 4px;
  }

  &::before {
    left: 0;
    transform: rotate(309deg);
  }

  &::after {
    right: 0;
    transform: rotate(235deg);
  }
`;
